import { privateAxios } from '@/services/api'

export const _getAllDevices = () => {
    return privateAxios.get('/devices')
        .then(response => response.data)
}

export const _getDevices = (data) => {
    return privateAxios.post('/devices/search', data)
        .then(response => response.data)
}

export const _addDevice = (data) => {
    return privateAxios.post('/devices', data)
        .then(response => response.data)
}

export const _updateDevice = (data) => {
    return privateAxios.put('/devices', data)
        .then(response => response.data)
}

export const _deleteDevice = (id) => {
    return privateAxios.delete(`/devices/${id}`)
        .then(response => response.data)
}

export const _pairDevice = (data) => {
    return privateAxios.put('devices/pair', data)
        .then(response => response.data)
}

export const _unpairDevice = (data) => {
    return privateAxios.put('/devices/unpair', data)
        .then(response => response.data)
}

export const _getGroups = () => {
    return privateAxios.get('/device-groups')
        .then(response => response.data)
}

export const _addGroup = (data) => {
    return privateAxios.post('/device-groups', data)
        .then(response => response.data)
}

export const _updateGroup = (data) => {
    return privateAxios.put('/device-groups', data)
        .then(response => response.data)
}

export const _deleteGroup = (id) => {
    return privateAxios.delete(`/device-groups/${id}`)
        .then(response => response.data)
}

export const _assignToDevice = (data) => {
    return privateAxios.put('/devices/assign', data)
        .then(response => response.data)
}

export const _checkDevicesStatus = (id, message) => {
    return privateAxios.get(`/devices/${id}/status/${message}`)
        .then(response => response.data)
}

export const _getDevicesCosts = () => {
    return privateAxios.get('/devices/costs')
        .then(response => response.data)
}
